
import { openDB } from "idb";

const DB_NAME = "dive-hrzn-image-cache";
const STORE_NAME = "images";

const dbPromise = openDB(DB_NAME, 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME);
    }
  },
});

export const getCachedImage = async (url) => {
  const db = await dbPromise;
  return db.get(STORE_NAME, url);
};

export const cacheImage = async (url, data) => {
  const db = await dbPromise;
  await db.put(STORE_NAME, data, url);
};

export const getImage = async (url) => {
  if (!url) return null;

  try {
    const cached = await getCachedImage(url);
    if (cached) return cached;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Image request failed: ${response.status}`);
    }

    const blob = await response.blob();

    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

    await cacheImage(url, dataUrl);

    return dataUrl;
  } catch (error) {
    console.error("Image caching failed:", url, error);
    return url;
  }
};

export const prepareItineraryImages = async (data) => {
  const urls = new Set([
    data.cover_image,
    ...(data.photos || []),
    ...(data.itinerary || []).map((day) => day.image),
  ]);

  const validUrls = [...urls].filter(Boolean);

  const results = await Promise.all(
    validUrls.map(async (url) => ({
      url,
      cachedImage: await getImage(url),
    }))
  );

  const imageMap = Object.fromEntries(
    results.map(({ url, cachedImage }) => [url, cachedImage])
  );

  return {
    ...data,
    cover_image: imageMap[data.cover_image] || data.cover_image,
    photos: (data.photos || []).map(
      (url) => imageMap[url] || url
    ),
    itinerary: (data.itinerary || []).map((day) => ({
      ...day,
      image: imageMap[day.image] || day.image,
    })),
  };
};
